import { useCallback, useState } from 'react';
import { ThemeContext } from './ThemeContext/ThemeContext';

export const ThemeProvider = ({ children }) => {
  const [themeSettings, setThemeSettings] = useState({
    activeMode: 'light',
    activeTheme: 'BLUE_THEME',
    activeDir: 'ltr',
    borderRadius: 7,
    isLanguage: 'enUS',
    mobileSidebarOpen: false,
    isSidebarHovered: false,
    isSidebarCollapsed: false,
    sidebarWidth: 256,
    sidebarWidthDialog: 285,
    miniSidebarWidth: 75,
    TopbarHeight: 70, // Default height
  });

  const updateThemeSettings = useCallback((newSettings) => {
    setThemeSettings((prev) => ({
      ...prev,
      ...newSettings,
    }));
  }, []);

  return (
    <ThemeContext.Provider value={{ ...themeSettings, updateThemeSettings }}>
      {children}
    </ThemeContext.Provider>
  );
};
